import AuthAPI from "./auth.js";
const Auth = new AuthAPI();

// Public
export function upload(file, notarizationId) {
	return Auth.POSTFile(`${url(notarizationId)}/Upload`, { file });
}

export function myDocuments(fileId, notarizationId) {
	let headers = new window.Headers();
	const data = new NotarizationDocumentExisting(fileId, null);
	return Auth.POST(url(notarizationId), data, headers);
}

export function lawDepot(dataId, notarizationId) {
	let headers = new window.Headers();
	const data = new NotarizationDocumentExisting(null, dataId);
	return Auth.POST(url(notarizationId), data, headers);
}

export function deleteDocument(fileId, notarizationId) {
	const uri = url(notarizationId) + `/` + fileId;
	return Auth.DELETE(uri);
}

// Private
function url(notarizationId) {
	let segments = [`/notarization`];
	if (notarizationId) segments.push(notarizationId);
	segments.push(`documents`);
	return segments.join(`/`);
}

class NotarizationDocumentExisting {
	constructor(fileId, dataId) {
		if (fileId == null && dataId == null) {
			throw new Error(`fileId and dataId cannot both be null`);
		}
		if (fileId)
			this.FileId = Number(fileId);
		if (dataId)
			this.DataId = Number(dataId);
	}
    FileId
    DataId
}